@if (loading) {
<div class="loading">
  <app-spinner color="#003082"></app-spinner>
</div>
} @else {
<router-outlet></router-outlet>
}